import { render, staticRenderFns } from "./ChangeHistory.vue?vue&type=template&id=ed439792&scoped=true"
import script from "./ChangeHistory.vue?vue&type=script&lang=js"
export * from "./ChangeHistory.vue?vue&type=script&lang=js"
import style0 from "./ChangeHistory.vue?vue&type=style&index=0&id=ed439792&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed439792",
  null
  
)

export default component.exports